import '../../css/home/participants_list.scss';
import {
    winW
} from '../share/components/_globeVar';
import { gsap } from "gsap";

$(function() {

    const app = Vue.createApp({
        data() {
            return {
                // data: [],
                // arr: [
                //     [],
                //     [],
                //     [],
                //     [],
                // ],
                result_row: [],
                column_num: 4,
                layout_row: false,
                loading_icon: false,
                // lang: null,
            }
        },
        mounted() {
            // const _this = this;

            // this.lang = _lang == 'tw' ? 'tw/' : '';
            this.result_row = _data;
            // const _arr = [167, 168, 169];
            // this.result_row.forEach(function(item, i) {
            //     if (_arr.includes(item.id)) {
            //         switch (item.id) {
            //             case 167:
            //                 _this.result_row[i].href = '/2023/' + _this.lang + 'list/smallworldjournal';
            //                 break;
            //             case 168:
            //                 _this.result_row[i].href = '/2023/' + _this.lang + 'content/swj-ju-chen-chen';
            //                 break;
            //             case 169:
            //                 _this.result_row[i].href = '/2023/' + _this.lang + 'content/swj-hu-tung-hui';
            //                 break;
            //             default:
            //                 _this.result_row[i].href = '/2023/' + _this.lang + 'content/' + item.addname;
            //         }

            //     } else {
            //         _this.result_row[i].href = '/2023/' + _this.lang + 'content/' + item.addname;
            //     }
            // });

            this.layout_fn('col');

            let _col_item;
            let _imagesLoaded;
            gsap.set(".col_list", { opacity: 0 });
            setTimeout(function() {
                gsap.set(".col_list", { duration: .1, opacity: 1 });
                gsap.set(".col_item", { opacity: 0 });
                _imagesLoaded = imagesLoaded('.col_list');
                _imagesLoaded.on('progress', function(instance, image) {
                    _col_item = $('.' + image.img.className).closest('.col_item');
                    gsap.to(_col_item, { duration: .3, opacity: 1, ease: 'power0.out' });
                });
            }, 400);

            $('a[href$="#"]').click(function(e) {
                e.preventDefault();
            });

            $('.backtotop').click(function(e) {
                e.preventDefault();
                gsap.to('html, body', {
                    duration: 1,
                    scrollTop: 0,
                    ease: 'quart.out'
                });
            });
        },
        methods: {
            // load_more() {
            //     this.loading_icon = true;
            //     setTimeout(() => {
            //         this.data = this.data.concat(this.data);
            //         this.loading_icon = false;
            //         this.layout_fn('col');
            //     }, 1000);
            // },
            layout_fn(layout) {
                this.column_num = winW <= 820 ? 2 : 4;
                this.layout_row = layout == 'row' ? true : false;
                // this.column_num = layout == 'row' ? (this.column_num - 1) : this.column_num;
                // this.sort_fn(this.column_num);
            },
            // sort_fn(column_num) {
            //     let _remainder;
            //     this.arr = [
            //         [],
            //         [],
            //         [],
            //         [],
            //     ];
            //     for (let i = 0; i < this.data.length; i++) {
            //         _remainder = i % column_num;
            //         switch (_remainder) {
            //             case 0:
            //                 this.arr[0].push(this.data[i]);
            //                 break;
            //             case 1:
            //                 this.arr[1].push(this.data[i]);
            //                 break;
            //             case 2:
            //                 this.arr[2].push(this.data[i]);
            //                 break;
            //             case 3:
            //                 this.arr[3].push(this.data[i]);
            //                 break;
            //             default:
            //         }
            //         this.result_row = this.arr[0].concat(this.arr[1], this.arr[2], this.arr[3]);
            //     }
            // }
        },
    }).mount('#app');
});